module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editReservationPopupBg d-flex flex-column align-items-center justify-content-center",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.handleBackgroundClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "popupArea bg-lightest py-3 px-4"
  }, [_c('div', {
    staticClass: "text-center fs-larger font-weight-600 pb-2 dark-top"
  }, [_vm._v("\n            Invoice Details\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mb-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', [_vm._v("PROFILE")]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "d-flex justify-content-right align-items-center position-relative"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "d-flex justify-content-right align-items-center position-relative"
  }, [_c('button', {
    staticClass: "btn blue mr-2",
    attrs: {
      "disabled": _vm.getIsSendingInvoiceToMailLoading
    },
    on: {
      "click": function($event) {
        return _vm.sendInvoice(_vm.selectedInvoice)
      }
    }
  }, [_vm._v("Send")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue mr-2",
    attrs: {
      "disabled": _vm.getIsPrintingInvoice || _vm.getIsCancellingInvoice
    },
    on: {
      "click": function($event) {
        return _vm.printInvoiceClicked(_vm.selectedInvoice.id)
      }
    }
  }, [_vm._v("Print")]), _vm._v(" "), (_vm.listActions.length > 0 && _vm.selectedInvoice.type.id != 1 && !_vm.getIsPrintingInvoice && !_vm.getIsCancellingInvoice && _vm.selectedInvoice.isActive && _vm.selectedInvoice.bookingInvoiceLinkedId === null) ? _c('three-dots', {
    attrs: {
      "items": _vm.listActions,
      "isLighter": true,
      "divClass": 'color-6'
    },
    on: {
      "input": _vm.selectedConnectionAction
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Document Type\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedInvoice.type.label
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Number\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedInvoice.code
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Date\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.formatDateDots(_vm.selectedInvoice.date)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Client\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedInvoice.name
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    VAT Number\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedInvoice.vatNr
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Amount\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.formatPrice(_vm.selectedInvoice.value) + ' €'
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Linked to\n                    "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": ((_vm.selectedInvoice.bookingRelationsQuantity) + " Booking" + (_vm.selectedInvoice.bookingRelationsQuantity > 1 ? 's':''))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pointer mt-1"
  }, [_c('span', {
    staticClass: "color-1",
    on: {
      "click": _vm.expandBookings
    }
  }, [_vm._v("View list")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.invoiceBookingsArr.length > 0) ? _c('div', {
    staticClass: "invoiceBookingsHolder darker bold d-flex flex-column"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("Linked to")]), _vm._v(" "), _c('div', _vm._l((_vm.invoiceBookingsArr), function(bookingRow) {
    return _c('div', {
      staticClass: "pointer",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openInvoiceBooking(bookingRow)
        }
      }
    }, [_c('span', {
      staticClass: "color-1"
    }, [_vm._v(_vm._s(_vm.formatTicketNumber(bookingRow.sequencialNumber)))]), _vm._v(" - " + _vm._s(bookingRow.event.product.name))])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.selectedInvoice.url != null) ? _c('div', {
    staticClass: "invoiceBookingsHolder darker bold d-flex flex-column"
  }, [_c('div', {
    staticClass: "invoiceLabel dark bold"
  }, [_vm._v("External Link")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "pointer dark bold"
  }, [_c('a', {
    staticClass: "color-1",
    attrs: {
      "target": "_blank",
      "href": _vm.selectedInvoice.url
    }
  }, [_vm._v("link")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex w-100 justify-content-end mb-2"
  }, [_c('button', {
    staticClass: "btn tertiary mr-3",
    on: {
      "click": _vm.closeSubModal
    }
  }, [_vm._v("Close")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f691ee9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Invoice/InvoiceModal.vue
// module id = 1611
// module chunks = 0